import { Injectable } from '@angular/core';

import {
  PortalAncillaryBundle,
  PortalPassengerNodeInput,
  PortalTierEnum,
} from '@app/services/api/api.types';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  protected state: State = { ...defaultState };

  getState() {
    return this.state;
  }

  patchState(state: Partial<State>) {
    this.state = { ...this.state, ...state };
  }

  resetState() {
    this.state = { ...defaultState, portalLink: this.state.portalLink };
  }
}

const defaultState: State = {
  portalLink: '',
  passengers: [],
};

export type State = {
  portalLink: string;
  passengers: PortalPassengerNodeInput[];
  disruptionProtection?: number;
  tipsAmount?: number;
  cancelForAnyReason?: number;
  promocode?: string;
  promocodeDiscountAmount?: number;
  bundle?: PortalAncillaryBundle;
  tier?: PortalTierEnum;
  /** True when the user explicitly chose the BASIC (no paid tier) booking option. */
  basicTierSelected?: boolean;
  perpetual?: boolean;
  /** Set from sign-in return URL to re-select bundle on ancillary page after auth. */
  bundleRestorePending?: boolean;
};
